import { ProjectMethodologyEnum } from 'gql/graphql';

import { useMemo } from 'react';

import { useBimUpdateContractOtherCost } from './useBimUpdateContractOtherCost';
import { useUerUpdateContractOtherCost } from './useUerUpdateContractOtherCost';
import type { IUseUpdateContractOtherCost } from './useUerUpdateContractOtherCost';

export const useUpdateContractOtherCost = (props: IUseUpdateContractOtherCost) => {
    const { methodology } = props;

    const isUer = useMemo(() => methodology === ProjectMethodologyEnum.Uer, [methodology]);

    const {
        makeRequest: uerUpdateContractOtherCostMakeRequest,
        reset: uerUpdateContractOtherCostReset,
        data: uerUpdateContractOtherCostData,
        status: uerUpdateContractOtherCostStatus,
    } = useUerUpdateContractOtherCost(props);

    const {
        makeRequest: bimUpdateContractOtherCostMakeRequest,
        reset: bimUpdateContractOtherCostReset,
        data: bimUpdateContractOtherCostData,
        status: bimUpdateContractOtherCostStatus,
    } = useBimUpdateContractOtherCost(props);

    return useMemo(
        () => ({
            updateContractOtherCostMakeRequest: isUer
                ? uerUpdateContractOtherCostMakeRequest
                : bimUpdateContractOtherCostMakeRequest,
            updateContractOtherCostReset: isUer ? uerUpdateContractOtherCostReset : bimUpdateContractOtherCostReset,
            updateContractOtherCostData: isUer ? uerUpdateContractOtherCostData : bimUpdateContractOtherCostData,
            updateContractOtherCostStatus: isUer ? uerUpdateContractOtherCostStatus : bimUpdateContractOtherCostStatus,
        }),
        [
            bimUpdateContractOtherCostData,
            bimUpdateContractOtherCostMakeRequest,
            bimUpdateContractOtherCostReset,
            bimUpdateContractOtherCostStatus,
            isUer,
            uerUpdateContractOtherCostData,
            uerUpdateContractOtherCostMakeRequest,
            uerUpdateContractOtherCostReset,
            uerUpdateContractOtherCostStatus,
        ],
    );
};
